const BASEURL = process.env.NODE_ENV === 'production' ? '/v3' : '/api';
const platformId = 1;
module.exports = {
  baseUrl: BASEURL,
  platformId,
};
